import * as index from '@syncfusion/ej2-treegrid';
index.TreeGrid.Inject( index.Filter,index.Page,index.Sort,index.Reorder,index.Toolbar,index.Aggregate,index.Resize,index.ColumnMenu,index.ExcelExport,index.PdfExport,index.CommandColumn,index.ContextMenu,index.Edit,index.Selection);
export * from '@syncfusion/ej2-treegrid';
